// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videoContainer {
    display: flex;
    justify-content: center;
}

.youtubeVideo {
    width: 100%;
    max-width: 850px;
    height: 30em;
    animation: fadeInGlobal 2s;
}

@media only screen and (max-width: 812px) {
    .youtubeVideo {
        height: 20em;
    }
}

@media only screen and (max-width: 600px) {
    .youtubeVideo {
        height: 30vh;
    }
}

@media only screen and (max-width: 500px) {
    .youtubeVideo {
        height: 12em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Home/HomeContent/EmbedYoutubeLogic/youtubeEmbed.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".videoContainer {\n    display: flex;\n    justify-content: center;\n}\n\n.youtubeVideo {\n    width: 100%;\n    max-width: 850px;\n    height: 30em;\n    animation: fadeInGlobal 2s;\n}\n\n@media only screen and (max-width: 812px) {\n    .youtubeVideo {\n        height: 20em;\n    }\n}\n\n@media only screen and (max-width: 600px) {\n    .youtubeVideo {\n        height: 30vh;\n    }\n}\n\n@media only screen and (max-width: 500px) {\n    .youtubeVideo {\n        height: 12em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
